<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.branches.index">
        <template v-slot:title>
          <span>{{ $t("branches.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.name')">
                <b-form-input
                    v-model="form.name"
                    :placeholder="$t('branches.name')"
                    :state="validateState('name')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('name') && !$v.form.name.required"
                    :state="!(validateState('name') && !$v.form.name.required)">
                  {{ $t('branches.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('branches.description')"
                    class="form-control form-control-solid"
                    :state="validateState('description')"
                    name="description"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('description') && !$v.form.description.required"
                    :state="!(validateState('description') && !$v.form.description.required)">
                  {{ $t('branches.validations.description.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.institution')">
                <multiple-select-input
                    v-if="institutions"
                    :model.sync="form.institution_id"
                    :values="institutions"
                    :multiple="false"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('institution_id') && !$v.form.institution_id.required"
                    :state="validateState('institution_id') && $v.form.institution_id.required">
                  {{ $t('branches.validations.institution.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.phone_number')">
                <b-form-input
                    v-model="form.phone_number"
                    :placeholder="$t('branches.phone_number')"
                    :state="validateState('phone_number')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('phone_number') && !$v.form.phone_number.required"
                    :state="!(validateState('phone_number') && !$v.form.phone_number.required)">
                  {{ $t('branches.validations.phone_number.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.city')">
                <multiple-select-input
                    :model.sync="form.city_id"
                    :values="cities"
                    :multiple="false"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('city_id') && !$v.form.city_id.required"
                    :state="validateState('city_id') && $v.form.city_id.required">
                  {{ $t('branches.validations.city.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.county')">
                <multiple-select-input
                    :disabled="!form.city_id"
                    :model.sync="form.county_id"
                    :values="counties"
                    :multiple="false"
                    label="name"
                    track-by="id"
                ></multiple-select-input>

                <b-form-invalid-feedback
                    v-if="!validateState('county_id') && !$v.form.county_id.required"
                    :state="validateState('county_id') && $v.form.county_id.required">
                  {{ $t('branches.validations.county.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.district')">
                <multiple-select-input
                    :disabled="!form.county_id"
                    :model.sync="form.district_id"
                    :values="districts"
                    :multiple="false"
                    label="name"
                    track-by="id"
                ></multiple-select-input>

                <b-form-invalid-feedback
                    v-if="!validateState('district_id') && !$v.form.district_id.required"
                    :state="validateState('district_id') && $v.form.district_id.required">
                  {{ $t('branches.validations.district.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.address')">
                <b-form-input
                    v-model="form.address"
                    :placeholder="$t('branches.address')"
                    class="form-control form-control-solid"
                    :state="validateState('address')"
                    name="address"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('address') && !$v.form.address.required"
                    :state="!(validateState('address') && !$v.form.address.required)">
                  {{ $t('branches.validations.address.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.latitude')">
                <b-form-input
                    v-model="form.latitude"
                    :placeholder="$t('branches.latitude')"
                    :state="validateState('latitude')"
                    class="form-control form-control-solid"
                    name="latitude"
                    type="text"

                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('latitude') && !$v.form.latitude.required"
                    :state="!(validateState('latitude') && !$v.form.latitude.required)">
                  {{ $t('branches.validations.latitude.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('branches.longitude')">
                <b-form-input
                    v-model="form.longitude"
                    :placeholder="$t('branches.longitude')"
                    :state="validateState('longitude')"
                    class="form-control form-control-solid"
                    name="longitude"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('longitude') && !$v.form.longitude.required"
                    :state="!(validateState('longitude') && !$v.form.longitude.required)">
                  {{ $t('branches.validations.longitude.required') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>

            <b-col lg="2" md="6" sm="12" xl="2">
              <b-form-group :label="$t('branches.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/branch.module";

import institutionModule, {
  ITEMS_ALL as INSTITUTION_ITEMS,
  MODULE_NAME as INSTITUTION_MODULE_NAME,
  GET_ALL_ITEMS as GET_INSTITUTION_ITEMS
} from "@/core/services/store/institution.module";

import cityModule, {
  ITEMS_ALL as CITY_ITEMS,
  MODULE_NAME as CITY_MODULE_NAME,
  GET_ALL_ITEMS as GET_CITY_ITEMS
} from "@/core/services/store/city.module";

import countyModule, {
  ITEMS_ALL as COUNTY_ITEMS,
  MODULE_NAME as COUNTY_MODULE,
  GET_ALL_ITEMS as GET_COUNTY_ITEMS
} from "@/core/services/store/county.module";

import districtModule, {
  ITEMS_ALL as DISTRICT_ITEMS,
  MODULE_NAME as DISTRICT_MODULE,
  GET_ALL_ITEMS as GET_DISTRICT_ITEMS
} from "@/core/services/store/district.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";

const _MODULE_NAME = MODULE_NAME;
const _INSTITUTION_MODULE_NAME = INSTITUTION_MODULE_NAME;
const _CITY_MODULE_NAME = CITY_MODULE_NAME;
const _COUNTY_MODULE = COUNTY_MODULE;
const _DISTRICT_MODULE = DISTRICT_MODULE;

export default {
  name: "BranchesCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_INSTITUTION_MODULE_NAME, institutionModule);
    registerStoreModule(_CITY_MODULE_NAME, cityModule);
    registerStoreModule(_COUNTY_MODULE, countyModule);
    registerStoreModule(_DISTRICT_MODULE, districtModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput
  },
  validations: {
    form: {
      name: {
        required
      },
      description: {
        required
      },
      institution_id: {
        required
      },
      city_id: {
        required
      },
      district_id: {
        required
      },
      county_id: {
        required
      },
      address: {
        required
      },
      phone_number: {
        required
      },
      latitude: {
        required
      },
      longitude: {
        required
      },
      status: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
     return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    institutions() {
      return store.getters[_INSTITUTION_MODULE_NAME + "/" + INSTITUTION_ITEMS] || [];
    },
    cities() {
      return store.getters[_CITY_MODULE_NAME + "/" + CITY_ITEMS] || [];
    },
    counties() {
      return store.getters[_COUNTY_MODULE + "/" + COUNTY_ITEMS] || [];
    },
    districts() {
      return store.getters[_DISTRICT_MODULE + "/" + DISTRICT_ITEMS] || [];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        name: null,
        description: null,
        institution_id: null,
        city_id: null,
        county_id: null,
        district_id: null,
        address: null,
        phone_number: null,
        latitude: null,
        longitude: null,
        status: true
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: "management.branches"})
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getInstitutions() {
      this.$store
          .dispatch(_INSTITUTION_MODULE_NAME + "/" + GET_INSTITUTION_ITEMS, {})
    },
    getCities() {
      this.$store
          .dispatch(_CITY_MODULE_NAME + "/" + GET_CITY_ITEMS, {})
    },
    getCounties() {
      let filter = {
        city_id: this.form.city_id
      }
      this.$store
          .dispatch(_COUNTY_MODULE + "/" + GET_COUNTY_ITEMS, {
            filters: filter,
          })
    },
    getDistricts() {
      let filter = {
        city_id: this.form.city_id,
        county_id: this.form.county_id
      }
      this.$store
          .dispatch(_DISTRICT_MODULE + "/" + GET_DISTRICT_ITEMS, {
            filters: filter
          })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);

      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "branches.edit_item" : "branches.create_item")}
    ]);

    if (this.institutions && !this.institutions.length) {
      this.getInstitutions();
    }

    if (this.cities && !this.cities.length) {
      this.getCities();
    }

    if (!this.counties && this.form.city_id) {
      this.getCounties();
    }

    if (!this.districts && this.form.city_id) {
      this.getDistricts();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    'form.city_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.getCounties();
      }
    },
    'form.county_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.getDistricts();
      }
    },
    cities: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form.city_id && typeof this.form.city_id !== 'object') {
              this.form.city_id = this.cities.find(subItem => +subItem.id === +this.form.city_id).id;
            }
          }
        }
      }, deep: true
    },
    counties: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form.county_id && typeof this.form.county_id !== 'object') {
              this.form.county_id = this.counties.find(subItem => +subItem.id === +this.form.county_id).id;
            }
          }
        }
      }, deep: true
    },
    districts: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form.district_id && typeof this.form.district_id !== 'object') {
              this.form.district_id = this.districts.find(subItem => +subItem.id === +this.form.district_id).id;
            }
          }

        }
      }, deep: true
    },
    item(value) {
      if (value) {
        let item = value.item;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }

        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({ name: "management.branches"});
                }
              });
          }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
